import { PaymentMethodEnum } from '@systemeio/ui'

export const allowedPaymentMethodsFunnels = Object.values(PaymentMethodEnum)
